import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { doctor1, doctor2, doctor3 } from "../../../utils/DoctorData";
import {
  doctor1,
  doctor2,
  doctor3,
  doctor4,
  doctor5,
} from "../../../utils/DoctorData";
import { IMG } from "../../../assets";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./Doctor.css";

const doctors = [doctor1, doctor2, doctor3, doctor4, doctor5]; // Array of all doctors
export default function Doctor() {
  const routeParams = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const controls = useAnimation();
  const { ref, inView } = useInView({ triggerOnce: false });
  const [isLoading, setIsLoading] = useState(true);
  const [isDoctorLoaded, setIsDoctorLoaded] = useState(false); // New state to control loading of the second container
  const [imageLoadedCount, setImageLoadedCount] = useState(0);

  // Filter other doctors excluding the currently selected one
  const otherDoctors = doctors.filter(
    (doc) => doc.id !== (data ? data.id : null)
  );

  const preloadImages = (imageUrls) => {
    return Promise.all(
      imageUrls.map(
        (url) =>
          new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.onload = resolve; // Resolve the promise if the image loads successfully
            img.onerror = reject; // Reject the promise if the image fails to load
          })
      )
    );
  };

  useEffect(() => {
    console.log("Checking if we need to preload images...");
    if (otherDoctors.length > 0 && imageLoadedCount === 0) {
      const imageUrls = otherDoctors.map((doc) => doc.img2);

      preloadImages(imageUrls)
        .then(() => {
          console.log("All images preloaded.");
          // Delay rendering by 1250ms after images are preloaded
          setTimeout(() => setIsDoctorLoaded(true), 1250);
        })
        .catch((error) => {
          console.error("Error loading images:", error);
          // Still delay rendering
          setTimeout(() => setIsDoctorLoaded(true), 1250);
        });
    }
  }, [otherDoctors, imageLoadedCount]);

  useEffect(() => {
    console.log("Checking if data is loaded and resetting state...");
    if (!isLoading && data && imageLoadedCount === 0) {
      // Only reset when new data is loaded and images are not yet loaded
      console.log("Data loaded, resetting state for the first load.");
      setIsDoctorLoaded(false);
      setImageLoadedCount(0);
    }
  }, [isLoading, imageLoadedCount]);

  useEffect(() => {
    console.log("isDoctorLoaded:", isDoctorLoaded);
  }, [isDoctorLoaded]);

  // Set the selected doctor based on route parameters
  useEffect(() => {
    const selectedDoctor = doctors.find(
      (doc) => doc.id === parseInt(routeParams.id)
    );
    setData(selectedDoctor || null);
    console.log("Selected Doctor after routeParams change: ", selectedDoctor); // Add logging here
  }, [routeParams, doctors]);

  useEffect(() => {
    if (inView) {
      controls.start({ opacity: 1, y: 0, transition: { duration: 1 } });
    } else {
      controls.start({ opacity: 0, y: -50 });
    }
  }, [inView, controls]);

  // // Load the "Meet the Doctors" container after the first container has been rendered
  // useEffect(() => {
  //   if (!isLoading && data) {
  //     // Delay the rendering of the second container by 500ms after the first one has loaded
  //     setTimeout(() => setIsDoctorLoaded(true), 1250);
  //   }
  // }, [isLoading, data]);

  // useEffect(() => {
  //   if (!isLoading && data && imageLoadedCount === 0) {
  //     // Only reset when new data is loaded and images are not yet loaded
  //     console.log("Data loaded, resetting state for the first load.");
  //     setIsDoctorLoaded(false);
  //     setImageLoadedCount(0);
  //   }
  // }, [isLoading, data, imageLoadedCount]);

  useEffect(() => {
    window.scrollTo(0, 0); // Ensures the page scrolls to the top on mount
  }, []);

  const handleDoctorClick = (id) => {
    navigate(`/${id}`);
    window.scrollTo(0, 0);
  };

  const SkeletonLoader = () => (
    <div className="flex flex-col items-center justify-center lg:pb-[7%] pb-[12%] pt-[8%] text-grow">
      <div className="mb-[3%]">
        <div className="w-full text-center lg:text-[60px] md:text-[52px] text-[40px] font-extralight mb-0 md:mb-[3%] leading-9 md:leading-0 animate-pulse">
          <div className="h-10 lg:h-12 bg-primary  w-100 mx-auto rounded"></div>
        </div>
      </div>
      <div className="flex lg:flex-row flex-col items-center justify-center w-full h-auto">
        {/* Replace map with multiple skeleton divs */}
        {[1, 2, 3, 4].map((_, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center mr-[4%] cursor-pointer mt-[7%] lg:mt-0 p-[2%] rounded-xl animate-pulse"
          >
            <div className="rounded-full">
              <div className="md:w-[250px] md:h-[250px] w-[180px] h-[180px] rounded-full bg-primary"></div>
            </div>
            <div className="text-center mt-4 flex items-center justify-center flex-col">
              <div className="lg:text-2xl text-xl font-extrabold py-[2%] bg-primary h-6 w-32 rounded"></div>
              <div className="lg:text-xl text-lg font-semibold mt-2 bg-primary h-5 w-24 rounded"></div>
              <div className="lg:text-lg font-light mt-2 bg-primary h-4 w-20 rounded"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="flex items-center justify-center px-5 h-full font-poppins w-full pt-[135px]">
      <div className="max-w-screen-2xl h-full w-full">
        {data && (
          <>
            <div className="">
              <div
                // ref={detailSectionRef}
                // initial="hidden"
                // animate={inViewAn ? "visible" : "hidden"}
                // variants={mapAnimation2}
                className="w-full h-full  gap-12  md:pt-[4%]  md:px-[6%] map-animation"
              >
                <div className="md:flex gap-10 map-animation-visible">
                  <div className=" w-auto h-auto md:mb-0 mb-5">
                    <img
                      // whileHover={{
                      //   scale: 1.04,
                      //   transition: { yoyo: Infinity },
                      // }}
                      src={data.img}
                        loading="lazy" // Use the loading attribute for lazy loading

                      alt="doctor"
                      className="md:h-[310px] w-[650px] object-cover rounded-3xl"
                      onLoad={() => setIsLoading(false)}
                    />
                  </div>
                  <div className="w-auto h-auto flex flex-col justify-center ">
                    <div>
                      <p className="lg:text-3xl md:text-2xl text-[23px] font-bold mb-[1%] md:text-start text-start tracking-wider md:tracking-normal">
                        {data.name}
                      </p>
                    </div>
                    <div>
                      <p className="lg:text-2xl md:text-xl text-lg font-semibold md:text-start text-start">
                        {data.designation}
                      </p>
                      <p className="lg:text-2xl md:text-xl text-lg font-normal mb-[1%] md:text-start text-start">
                        {data.speciality}
                      </p>
                    </div>
                    <div className="w-auto lg:pr-[10%] ">
                      <p className="lg:text-base text-sm ">{data.text}</p>
                    </div>
                  </div>
                </div>

                <div className=" lg:flex items-start justify-start gap-15  lg:mt-15 md:mt-10 mt-7">
                  <div className="bg-[#E1FFFF] md:bg-white lg:w-[50%] mb-[4%] md:mb-[6%] lg:mb-0 pt-8 pb-11 px-[8%] md:px-0 md:pt-0 md:pb-0 rounded-[10px]">
                    <div className="lg:flex-col lg:items-start md:flex items-center lg:gap-0 gap-4 lg:mb-0 mb-2">
                      <img
                        src={IMG.MEM}
                        alt=""
                        className="lg:w-15 md:w-10 w-12 mb-[1%] md:mb-0"
                      />
                      <p className="lg:text-2xl text-xl font-bold md:font-semibold lg:mb-[1%] text-grow font-poppins tracking-wider lg:py-2">
                        MEMBERSHIPS
                      </p>
                    </div>
                    <ul>
                      {data.memberships.map((membership, index) => (
                        <li
                          // variants={listItemAnimation}
                          // initial="rest"
                          // whileHover="hover"
                          key={index}
                          className="flex text-[#5b6370] lg:mt-0 mt-1 "
                        >
                          <img
                            src={IMG.MINUS}
                            alt="arrow"
                            className="mr-2 object-contain self-start w-[5%] md:w-auto mt-[1%] md:mt-0"
                          />
                          <p className="lg:text-lg md:font-semibold text-[13px] md:text-base tracking-wider md:tracking-normal lg:pb-2">
                            {membership}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-[#E1FFFF] md:bg-white lg:w-[50%] py-6 px-[8%] md:px-0 md:py-0 rounded-[10px]">
                    <div className="lg:flex-col lg:items-start md:flex items-center lg:gap-0 gap-4 lg:mb-0 mb-2">
                      <img
                        src={IMG.EDU}
                        alt=""
                        className="lg:w-15 md:w-10 w-12 mb-[1%] md:mb-0"
                      />
                      <p className="lg:text-2xl text-xl font-bold md:font-semibold lg:mb-[1%] text-grow font-poppins tracking-wider lg:py-2">
                        EDUCATION
                      </p>
                    </div>
                    <ul>
                      {data.education.map((edu, index) => (
                        <li
                          // variants={listItemAnimation}
                          // initial="rest"
                          // whileHover="hover"
                          key={index}
                          className="mb-2 text-[#5b6370] "
                        >
                          <div className="text-black font-medium md:font-bold lg:text-lg text-[13px] lg:pb-2">
                            {edu.heading}
                          </div>
                          <ul>
                            {edu.descriptions.map((description, descIndex) => (
                              <li
                                key={descIndex}
                                className="flex items-center lg:mt-0 mt-1"
                              >
                                <img
                                  src={IMG.MINUS}
                                  alt="arrow"
                                  className="mr-2 object-contain self-start w-[5%] md:w-auto mt-[1%] md:mt-0"
                                />
                                <p className="lg:text-lg md:font-normal text-[13px] md:text-base tracking-wider md:tracking-normal pb-1">
                                  {description}
                                </p>
                              </li>
                            ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Conditionally render the "Meet the Doctors" container */}
            {isDoctorLoaded ? (
              <div className="flex flex-col items-center justify-center lg:pb-[7%] pb-[12%] pt-[8%] text-grow">
                <div
                  // ref={ref}
                  // initial={{ opacity: 0, y: -20 }}
                  // animate={controls}
                  className="mb-[3%] autoShow"
                >
                  <p className="w-full text-center lg:text-[60px] md:text-[52px] text-[40px] font-extralight mb-0 md:mb-[3%] leading-9 md:leading-0">
                    Meet the <span className="font-bold">Doctors</span>
                  </p>
                </div>
                <div className="flex lg:flex-row flex-col items-center justify-center w-full h-auto">
                  {otherDoctors.map((doc) => (
                    <motion.div
                      whileHover={{
                        scale: 1.04,
                        boxShadow: "0 8px 20px rgba(58, 162, 151, 0.6)",
                        transition: {
                          scale: {
                            type: "spring",
                            stiffness: 300,
                            damping: 20,
                          },
                          boxShadow: {
                            type: "spring",
                            stiffness: 300,
                            damping: 20,
                          },
                        },
                      }}
                      key={doc.id}
                      onClick={() => handleDoctorClick(doc.id)}
                      className="flex flex-col items-center justify-center mr-[4%] cursor-pointer mt-[7%] lg:mt-0 p-[2%] rounded-xl"
                    >
                      <div className="rounded-full">
                        <img
                          src={doc.img2}
                          alt="doc_img"
                          className="md:w-[250px] md:h-[250px] w-[180px] h-[180px] rounded-full object-cover"
                        />
                      </div>
                      <div className="text-center">
                        <p className="lg:text-2xl text-xl font-extrabold py-[2%]">
                          {doc.name}
                        </p>
                        <p className="lg:text-xl text-lg font-semibold">
                          {doc.designation}
                        </p>
                        <p className="lg:text-lg font-light">
                          {doc.speciality}
                        </p>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </div>
            ) : (
              <SkeletonLoader />
            )}
          </>
        )}
      </div>
    </div>
  );
}

// export default function Doctor() {
//   const routeParams = useParams();
//   const navigate = useNavigate();
//   const [data, setData] = useState(null);
//   // const detailSectionRef = useRef(null);
//   const controls = useAnimation();
//   const { ref, inView } = useInView({ triggerOnce: false });
//   const [isLoading, setIsLoading] = useState(true);

//   // useEffect(() => {
//   //   // Scroll to top when the component mounts or when the route changes
//   //   window.scrollTo({
//   //     top: 0,
//   //     behavior: "smooth",
//   //   });
//   // }, []);

//   useEffect(() => {
//     const selectedDoctor = doctors.find(
//       (doc) => doc.id === parseInt(routeParams.id)
//     );
//     console.log("selectedDoctor in ", selectedDoctor);
//     setData(selectedDoctor || null);
//   }, [routeParams]);

//   useEffect(() => {
//     if (inView) {
//       controls.start({ opacity: 1, y: 0, transition: { duration: 1 } });
//     } else {
//       controls.start({ opacity: 0, y: -50 });
//     }
//   }, [inView, controls]);

//   // Get the list of other doctors excluding the currently selected one
//   const otherDoctors = doctors.filter(
//     (doc) => doc.id !== (data ? data.id : null)
//   );

//   const smoothScrollTo = (element, duration) => {
//     const start = window.scrollY;
//     const target = element.getBoundingClientRect().top + window.scrollY;
//     const headerOffset = 100; // Adjust this based on your header's height
//     const distance = target - start - headerOffset;
//     let startTime = null;

//     const scroll = (currentTime) => {
//       if (startTime === null) startTime = currentTime;
//       const progress = currentTime - startTime;
//       const progressRatio = Math.min(progress / duration, 1);
//       window.scrollTo(0, start + distance * progressRatio);
//       if (progress < duration) {
//         requestAnimationFrame(scroll);
//       }
//     };

//     requestAnimationFrame(scroll);
//   };

//   const listItemAnimation = {
//     rest: { scale: 1, opacity: 1 },
//     hover: { scale: 1.05, opacity: 0.8, transition: { duration: 0.3 } },
//   };

//   const handleDoctorClick = (id) => {
//     window.scrollTo(0, 0); // Ensures the page scrolls to the top on mount

//     // const selectedDoctor = doctors.find((doc) => doc.id === id);
//     navigate(`/${id}`);

//     // setData(selectedDoctor);
//     // console.log("Scrolling to:", detailSectionRef.current); // Check this output
//     // if (detailSectionRef.current) {
//     // smoothScrollTo(detailSectionRef.current, 600);
//     // }
//   };

//   // useEffect(() => {
//   //   // This effect runs when the data (doctor details) is updated
//   //   if (data && detailSectionRef.current) {
//   //     // Scroll smoothly to the section containing the doctor's details
//   //     // smoothScrollTo(detailSectionRef.current, 600);
//   //     window.scrollTo({
//   //       top: 0,
//   //       behavior: "smooth",
//   //     });
//   //   }
//   // }, [data]);

//   // useEffect(() => {
//   //   // Smooth scroll function
//   //   const smoothScrollToTop = (duration) => {
//   //     const startPosition = window.pageYOffset;
//   //     const startTime = performance.now();

//   //     const animateScroll = (currentTime) => {
//   //       const elapsedTime = currentTime - startTime;
//   //       const progress = Math.min(elapsedTime / duration, 1);

//   //       // Easing function (ease-in-out)
//   //       const easeInOutCubic = (t) =>
//   //         t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

//   //       const easedProgress = easeInOutCubic(progress);
//   //       const scrollPosition = startPosition * (1 - easedProgress);

//   //       window.scrollTo(0, scrollPosition);

//   //       if (progress < 1) {
//   //         requestAnimationFrame(animateScroll);
//   //       }
//   //     };

//   //     requestAnimationFrame(animateScroll);
//   //   };

//   //   if (data) {
//   //     // Trigger smooth scroll to top when data is available
//   //     smoothScrollToTop(900); // Scroll over 600ms
//   //   }
//   // }, [data]);

//   // const [mapInViewRef, inViewAn] = useInView({ threshold: 0 });
//   const mapAnimation2 = {
//     hidden: { opacity: 0, scale: 1.5 },
//     visible: {
//       opacity: 1,
//       scale: 1,
//       transition: { duration: 1.5 },
//     },
//   };

//   const SkeletonLoader = () => {
//     return (
//       <div className="md:h-[310px] w-[448px] bg-gray rounded-3xl animate-pulse" />
//     );
//   };

//   return (
//     <div className="flex items-center justify-center px-5 h-full font-poppins w-full pt-[130px]">
//       <div className="max-w-screen-2xl h-full w-full">
//         {data && (
//           <>
//             <div className="">
//               <div
//                 // ref={detailSectionRef}
//                 // initial="hidden"
//                 // animate={inViewAn ? "visible" : "hidden"}
//                 // variants={mapAnimation2}
//                 className="w-full h-full  gap-12  md:pt-[4%]  md:px-[6%] map-animation"
//               >
//                 <div className="md:flex gap-10 map-animation-visible">
//                   <div className=" w-auto h-auto md:mb-0 mb-5">

//                     <img
//                       // whileHover={{
//                       //   scale: 1.04,
//                       //   transition: { yoyo: Infinity },
//                       // }}
//                       src={data.img}
//                       alt="doctor"
//                       className="md:h-[310px] w-[650px] object-cover rounded-3xl"
//                       onLoad={() => setIsLoading(false)}
//                     />
//                   </div>
//                   <div className="w-auto h-auto flex flex-col justify-center ">
//                     <div>
//                       <p className="lg:text-3xl md:text-2xl text-[23px] font-bold mb-[1%] md:text-start text-start tracking-wider md:tracking-normal">
//                         {data.name}
//                       </p>
//                     </div>
//                     <div>
//                       <p className="lg:text-2xl md:text-xl text-lg font-semibold md:text-start text-start">
//                         {data.designation}
//                       </p>
//                       <p className="lg:text-2xl md:text-xl text-lg font-normal mb-[1%] md:text-start text-start">
//                         {data.speciality}
//                       </p>
//                     </div>
//                     <div className="w-auto lg:pr-[10%] ">
//                       <p className="lg:text-base text-sm ">{data.text}</p>
//                     </div>
//                   </div>
//                 </div>

//                 <div className=" lg:flex items-start justify-start gap-15  lg:mt-15 md:mt-10 mt-7">
//                   <div className="bg-[#E1FFFF] md:bg-white lg:w-[50%] mb-[4%] md:mb-[6%] lg:mb-0 pt-8 pb-11 px-[8%] md:px-0 md:pt-0 md:pb-0 rounded-[10px]">
//                     <div className="lg:flex-col lg:items-start md:flex items-center lg:gap-0 gap-4 lg:mb-0 mb-2">
//                       <img
//                         src={IMG.MEM}
//                         alt=""
//                         className="lg:w-15 md:w-10 w-12 mb-[1%] md:mb-0"
//                       />
//                       <p className="lg:text-2xl text-xl font-bold md:font-semibold lg:mb-[1%] text-grow font-poppins tracking-wider py-2">
//                         MEMBERSHIPS
//                       </p>
//                     </div>
//                     <ul>
//                       {data.memberships.map((membership, index) => (
//                         <li
//                           // variants={listItemAnimation}
//                           // initial="rest"
//                           // whileHover="hover"
//                           key={index}
//                           className="flex text-[#5b6370] lg:mt-0 mt-1 "
//                         >
//                           <img
//                             src={IMG.MINUS}
//                             alt="arrow"
//                             className="mr-2 object-contain self-start w-[5%] md:w-auto mt-[1%] md:mt-0"
//                           />
//                           <p className="lg:text-lg md:font-semibold text-[13px] md:text-base tracking-wider md:tracking-normal pb-2">
//                             {membership}
//                           </p>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>

//                   <div className="bg-[#E1FFFF] md:bg-white lg:w-[50%] py-6 px-[8%] md:px-0 md:py-0 rounded-[10px]">
//                     <div className="lg:flex-col lg:items-start md:flex items-center lg:gap-0 gap-4 lg:mb-0 mb-2">
//                       <img
//                         src={IMG.EDU}
//                         alt=""
//                         className="lg:w-15 md:w-10 w-12 mb-[1%] md:mb-0"
//                       />
//                       <p className="lg:text-2xl text-xl font-bold md:font-semibold lg:mb-[1%] text-grow font-poppins tracking-wider py-2">
//                         EDUCATION
//                       </p>
//                     </div>
//                     <ul>
//                       {data.education.map((edu, index) => (
//                         <li
//                           // variants={listItemAnimation}
//                           // initial="rest"
//                           // whileHover="hover"
//                           key={index}
//                           className="mb-2 text-[#5b6370] "
//                         >
//                           <div className="text-black font-medium md:font-bold lg:text-lg text-[13px] pb-2">
//                             {edu.heading}
//                           </div>
//                           <ul>
//                             {edu.descriptions.map((description, descIndex) => (
//                               <li
//                                 key={descIndex}
//                                 className="flex items-center lg:mt-0 mt-1"
//                               >
//                                 <img
//                                   src={IMG.MINUS}
//                                   alt="arrow"
//                                   className="mr-2 object-contain self-start w-[5%] md:w-auto mt-[1%] md:mt-0"
//                                 />
//                                 <p className="lg:text-lg md:font-normal text-[13px] md:text-base tracking-wider md:tracking-normal pb-1">
//                                   {description}
//                                 </p>
//                               </li>
//                             ))}
//                           </ul>
//                         </li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="flex flex-col items-center justify-center lg:pb-[7%] pb-[12%] pt-[8%] text-grow">
//               <motion.div
//                 ref={ref}
//                 initial={{ opacity: 0, y: -100 }}
//                 animate={controls}
//                 className="mb-[3%]"
//               >
//                 <p className="w-full text-center lg:text-[60px] md:text-[52px] text-[40px] font-extralight mb-0 md:mb-[3%] leading-9 md:leading-0">
//                   Meet the <span className="font-bold">Doctors</span>
//                 </p>
//               </motion.div>
//               <div className="flex lg:flex-row flex-col items-center justify-center w-full h-auto  ">
//                 {otherDoctors.map((doc) => (
//                   <motion.div
//                     whileHover={{
//                       scale: 1.04,
//                       boxShadow: "0 8px 20px rgba(58, 162, 151, 0.6)",
//                       transition: {
//                         scale: { type: "spring", stiffness: 300, damping: 20 },
//                         boxShadow: {
//                           type: "spring",
//                           stiffness: 300,
//                           damping: 20,
//                         },
//                         yoyo: Infinity,
//                       },
//                     }}
//                     key={doc.id}
//                     onClick={() => handleDoctorClick(doc.id)}
//                     className="flex flex-col items-center justify-center mr-[4%] cursor-pointer mt-[7%] lg:mt-0 p-[2%] rounded-xl"
//                   >
//                     <div className=" rounded-full">
//                       <img
//                         src={doc.img2}
//                         alt="doc_img"
//                         className="md:w-[250px] md:h-[250px] w-[180px] h-[180px] rounded-full object-cover"
//                       />
//                     </div>
//                     <div className="text-center">
//                       <p className="lg:text-2xl text-xl font-extrabold py-[2%]">
//                         {doc.name}
//                       </p>
//                       <p className="lg:text-xl text-lg font-semibold">
//                         {doc.designation}
//                       </p>
//                       <p className="lg:text-lg font-light">{doc.speciality}</p>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }
